import { CircleAlert, CircleCheck } from 'lucide-react'
import { forwardRef } from 'react'

import { Badge, Tooltip } from 'slab'

import { listToProseString } from '../../utils'

interface WhoPaysBadgeProps {
  thatchPays: boolean;
  bordered?: boolean;
  carrierNames?: string[];
}

export const WhoPaysBadge = forwardRef<HTMLSpanElement, WhoPaysBadgeProps>(
  ({ thatchPays, bordered = false, carrierNames }, forwardedRef) => {
    const type = thatchPays ? 'slate' : 'info'
    const leftIcon = thatchPays ? CircleCheck : CircleAlert

    let badgeText: string = thatchPays ? 'Paid by Thatch' : 'You\'re paying'
    const tooltipContent: string = thatchPays ? 'We\'re in charge of enrolling you and paying for this plan' : 'You\'re responsible for enrolling and setting up autopay for this plan'

    if (carrierNames && carrierNames.length > 0) {
      const payerAndVerb = thatchPays ? 'Thatch is paying' : 'You must pay'
      const pluralizedPremium = carrierNames.length > 1 ? 'premiums' : 'premium'
      const carrierNamesString = listToProseString(carrierNames)

      badgeText = `${payerAndVerb} your ${pluralizedPremium} for ${carrierNamesString}`
    }

    return (
      <div className='whitespace-nowrap cursor-pointer'>
        <Tooltip
          align='center'
          content={tooltipContent}
          side='bottom'
          zIndex={60}
        >
          <Badge leftIcon={leftIcon} type={type} bordered={bordered} ref={forwardedRef}>
            {badgeText}
          </Badge>
        </Tooltip>
      </div>
    )
  }
)
